import { useState } from 'react';

export function MicroTeach3() {
	const [docFont, setDocFont] = useState("Helvetica, Arial, sans-serif");
	const [warmUpDone, setWarmUpDone] = useState(false);
	const [targetDone, setTargetDone] = useState(false);
	const [initiation, setInitiation] = useState(false);
	const [expectations, setExpectations] = useState(false);

	function text2Speech(num) {
		const e = document.getElementById("question" + num);
		navigator.clipboard.writeText(e.textContent);
		alert(`Text for question ${num} copied to clipboard. Ready to paste.`)
		window.open("https://www.naturalreaders.com/online/");
	}

	function translateText(num) {
		const e = document.getElementById("question" + num);
		navigator.clipboard.writeText(e.textContent);
		window.open("http://translate.google.com/?sl=en&tl=th&op=translate&text=" + e.textContent.replaceAll("%", "%25"));
	}

	function changeFont() {
		const e = document.getElementById("select_font");
		setDocFont(e.value);
	}

	function gotoLT() {
		setWarmUpDone(true);
	}

	function gotoInit() {
		setTargetDone(true);
	}

	function gotoExpect() {
		setInitiation(true);
	}

	function gotoWP() {
		setExpectations(true);
	}

	if (!warmUpDone) {
		return (
			<>
				<div className="microteach" style={{ "fontFamily": `${docFont}` }}>

					<h1>
						<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >Warm-Up</span>
					</h1>

					<h4>
						<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >
							Match each word on the left side with its definition on the right side:</span>
					</h4>

					<table style={{ "marginLeft": "50px" }}>
						<tbody>
							<tr>
								<td width="200">Balance</td>
								<td width="50"><input className="larger-text" type="text" size="1" style={{ "textAlign": "center" }} /></td>
								<td width="100">&nbsp;</td>
								<td width="500">A.&nbsp;&nbsp;a quantity based on comparison to a standard unit</td>
							</tr>
							<tr>
								<td width="200">Calculation</td>
								<td width="50"><input className="larger-text" type="text" size="1" style={{ "textAlign": "center" }} /></td>
								<td width="100">&nbsp;</td>
								<td width="500">B.&nbsp;&nbsp;standard quantities used to measure and express values</td>
							</tr>
							<tr>
								<td width="200">Check</td>
								<td width="50"><input className="larger-text" type="text" size="1" style={{ "textAlign": "center" }} /></td>
								<td width="100">&nbsp;</td>
								<td width="500">C.&nbsp;&nbsp;a mathematical formula that expresses the equality of two expressions</td>
							</tr>
							<tr>
								<td width="200">Conversion</td>
								<td width="50"><input className="larger-text" type="text" size="1" style={{ "textAlign": "center" }} /></td>
								<td width="100">&nbsp;</td>
								<td width="500">D.&nbsp;&nbsp;the remaining amount after a change is applied</td>
							</tr>
							<tr>
								<td width="200">Decline</td>
								<td width="50"><input className="larger-text" type="text" size="1" style={{ "textAlign": "center" }} /></td>
								<td width="100">&nbsp;</td>
								<td width="500">E.&nbsp;&nbsp;the result obtained by multiplying values</td>
							</tr>
							<tr>
								<td width="200">Equation</td>
								<td width="50"><input className="larger-text" type="text" size="1" style={{ "textAlign": "center" }} /></td>
								<td width="100">&nbsp;</td>
								<td width="500">F.&nbsp;&nbsp;verifying calculations, assumptions, or reasoning</td>
							</tr>
							<tr>
								<td width="200">Expression</td>
								<td width="50"><input className="larger-text" type="text" size="1" style={{ "textAlign": "center" }} /></td>
								<td width="100">&nbsp;</td>
								<td width="500">G.&nbsp;&nbsp;a deliberate mathematical process that transforms inputs into outputs</td>
							</tr>
							<tr>
								<td width="200">Integer</td>
								<td width="50"><input className="larger-text" type="text" size="1" style={{ "textAlign": "center" }} /></td>
								<td width="100">&nbsp;</td>
								<td width="500">H.&nbsp;&nbsp;whole numbers that can be positive, negative, or zero</td>
							</tr>
							<tr>
								<td width="200">Measurement</td>
								<td width="50"><input className="larger-text" type="text" size="1" style={{ "textAlign": "center" }} /></td>
								<td width="100">&nbsp;</td>
								<td width="500">J.&nbsp;&nbsp;transforming one quantity, unit, or representation into another</td>
							</tr>
							<tr>
								<td width="200">Product</td>
								<td width="50"><input className="larger-text" type="text" size="1" style={{ "textAlign": "center" }} /></td>
								<td width="100">&nbsp;</td>
								<td width="500">K.&nbsp;&nbsp;decrease or reduction in a quantity or value</td>
							</tr>
							<tr>
								<td width="200">Solution</td>
								<td width="50"><input className="larger-text" type="text" size="1" style={{ "textAlign": "center" }} /></td>
								<td width="100">&nbsp;</td>
								<td width="500">L.&nbsp;&nbsp;an arrangement of symbols following mathematical notation</td>
							</tr>
							<tr>
								<td width="200">Units</td>
								<td width="50"><input className="larger-text" type="text" size="1" style={{ "textAlign": "center" }} /></td>
								<td width="100">&nbsp;</td>
								<td width="500">M.&nbsp;&nbsp;the result attained from completing a mathematical procedure or process</td>
							</tr>
							<tr>
								<td width="200">Yield</td>
								<td width="50"><input className="larger-text" type="text" size="1" style={{ "textAlign": "center" }} /></td>
								<td width="100">&nbsp;</td>
								<td width="500">N.&nbsp;&nbsp;the result or output of a process or procedure</td>
							</tr>
						</tbody>
					</table>

					<p>&nbsp;</p>

					<button type="button" className="gray-button" onClick={() => gotoLT()}>Done! Next ...</button>
				</div >
			</>
		);
	}
	else if (!targetDone) {
		return (
			<>
				<div className="microteach" style={{ "fontFamily": `${docFont}`, "textAlign": "center" }}>

					<h1>
						<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >Learning Target</span>
					</h1>

					<p>
						<label id="question999">
							I can interpret, setup, and solve a set of sample PSAT word problems, <br />
							trying 4 available approaches/methods <br />
							and 4 assistance options, <br />
							achieving a minimum accuracy of 50%.
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(999)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(999)}>Translate</button>

					<p>&nbsp;</p>

					<button type="button" className="gray-button" onClick={() => gotoInit()}>Done! Next ...</button>
				</div >
			</>
		);
	}
	else if (!initiation) {
		return (
			<>
				<div className="microteach" style={{ "fontFamily": `${docFont}`, "textAlign": "center" }}>

					<h1>
						<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >What is a word problem?</span>
					</h1>

					<p>
						<label id="question998">
							Consider the relationship between words and mathematical processes.<br />
							<br />
							How are mathematics represented in real-world scenarios?<br />
							<br />
							When the world needs a mathematical solution to a problem,<br />
							how is the problem usually described?
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(998)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(998)}>Translate</button>

					<p>&nbsp;</p>

					<button type="button" className="gray-button" onClick={() => gotoExpect()}>Done! Next ...</button>
				</div >
			</>
		);
	}
	else if (!expectations) {
		return (
			<>
				<div className="microteach" style={{ "fontFamily": `${docFont}` }}>

					<h1>
						<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >Expectations for Today</span>
					</h1>

					<p>
						<label id="question997">
							1. Read through the eight available word problems. <br />
							2. Choose four of the word problems to solve (your choice). <br />
							3. Map each of your chosen word problems to a separate approach/method <br />
							&nbsp; &nbsp; AND a separate assistance option (your choice). <br />
							4. We will solve one word problem at a time. You have 2 minutes to complete each problem. <br />
							5. Achieving 50% (half) correct is passing.
						</label>
					</p>

					<button type="button" className="gray-button" onClick={() => text2Speech(997)}>Text to Speech</button>
					<button type="button" className="gray-button" onClick={() => translateText(997)}>Translate</button>

					<p>&nbsp;</p>

					<button type="button" className="gray-button" onClick={() => gotoWP()}>Done! Next ...</button>
				</div >
			</>
		);
	}
	else {
		return (
			<>
				<div className="microteach">
					Select a font: &nbsp;
					<select className="microteach" id="select_font" style={{ "width": "250px" }} onChange={() => changeFont()}>
						<option defaultValue value="Arial">Arial</option>
						<option value="Arial Black">Arial Black</option>
						<option value="Comic Sans MS">Comic Sans MS</option>
						<option value="Georgia">Georgia</option>
						<option value="Impact">Impact</option>
						<option value="Times New Roman">Times New Roman</option>
					</select>
				</div>

				<p>&nbsp;</p>

				<div className="microteach" style={{ "fontFamily": `${docFont}` }}>

					<h1>
						<span style={{ "color": "#005F00", "paddingLeft": "20px" }} >PSAT Word Problem Practice</span>
					</h1>

					<p>&nbsp;</p>

					<ol>
						<li>
							<label id="question1">
								Henry receives a $60.00 gift card to pay for movies online.
								He uses his gift card to buy 3 movies for $7.50 each.
								If he spends the rest of his gift card balance on renting movies for $1.50 each,
								how many movies can Henry rent?
							</label>

							<br />
							<button type="button" className="gray-button" onClick={() => text2Speech(1)}>Text to Speech</button>
							<button type="button" className="gray-button" onClick={() => translateText(1)}>Translate</button>
							<br /><br />

							<input type="radio" id="1A" name="answer1" value="A" /><label className="list_label" htmlFor="1A">10</label><br />
							<input type="radio" id="1B" name="answer1" value="B" /><label className="list_label" htmlFor="1B">25</label><br />
							<input type="radio" id="1C" name="answer1" value="C" /><label className="list_label" htmlFor="1C">35</label><br />
							<input type="radio" id="1D" name="answer1" value="D" /><label className="list_label" htmlFor="1D">40</label><br />
						</li>

						<br /><br />

						<li>
							<label id="question2">
								A sample of a certain alloy has a total mass of 50.0 grams and is 50.0% silicon by mass.
								The sample was created by combining two pieces of different alloys.
								The first piece was 30.0% silicon by mass, and the second piece was 80.0% silicon by mass.
								What was the mass, in grams, on the silicon in the second piece?
							</label>

							<br />
							<button type="button" className="gray-button" onClick={() => text2Speech(2)}>Text to Speech</button>
							<button type="button" className="gray-button" onClick={() => translateText(2)}>Translate</button>
							<br /><br />

							<input type="radio" id="2A" name="answer2" value="A" /><label className="list_label" htmlFor="2A">9.0</label><br />
							<input type="radio" id="2B" name="answer2" value="B" /><label className="list_label" htmlFor="2B">16.0</label><br />
							<input type="radio" id="2C" name="answer2" value="C" /><label className="list_label" htmlFor="2C">20.0</label><br />
							<input type="radio" id="2D" name="answer2" value="D" /><label className="list_label" htmlFor="2D">30.0</label><br />
						</li>

						<br /><br />

						<li>
							<label id="question3">
								In a certain game, a player can solve easy or hard puzzles.
								A player earns 30 points for solving an easy puzzle and 60 points for solving a hard puzzle.
								Tina solved a total of 50 puzzles playing this game, earning 1,950 points in all.
								How many hard puzzles did Tina solve?
							</label>

							<br />
							<button type="button" className="gray-button" onClick={() => text2Speech(3)}>Text to Speech</button>
							<button type="button" className="gray-button" onClick={() => translateText(3)}>Translate</button>
							<br /><br />

							<input type="radio" id="3A" name="answer3" value="A" /><label className="list_label" htmlFor="3A">10</label><br />
							<input type="radio" id="3B" name="answer3" value="B" /><label className="list_label" htmlFor="3B">15</label><br />
							<input type="radio" id="3C" name="answer3" value="C" /><label className="list_label" htmlFor="3C">25</label><br />
							<input type="radio" id="3D" name="answer3" value="D" /><label className="list_label" htmlFor="3D">35</label><br />
						</li>

						<br /><br />

						<li>
							<label id="question4">
								Boyd grows only tomatoes and raspberries in his garden.
								Last year, he grew 140 pounds of tomatoes and 60 pounds of raspberries.
								This year, the production, by weight, of tomatoes declined by 20 percent,
								and the production, by weight, of raspberries declined by 50 percent.
								By what percentage did the total yield, by weight, of Boyd&apos;s garden decline?
							</label>

							<br />
							<button type="button" className="gray-button" onClick={() => text2Speech(4)}>Text to Speech</button>
							<button type="button" className="gray-button" onClick={() => translateText(4)}>Translate</button>
							<br /><br />

							<input type="radio" id="4A" name="answer4" value="A" /><label className="list_label" htmlFor="4A">29 percent</label><br />
							<input type="radio" id="4B" name="answer4" value="B" /><label className="list_label" htmlFor="4B">30 percent</label><br />
							<input type="radio" id="4C" name="answer4" value="C" /><label className="list_label" htmlFor="4C">35 percent</label><br />
							<input type="radio" id="4D" name="answer4" value="D" /><label className="list_label" htmlFor="4D">70 percent</label><br />
						</li>

						<br /><br />

						<li>
							<label id="question5">
								Juliene practiced her dance routine for twice as many minutes on Monday as she did on Tuesday.
								She practiced her routine those two days for a total of 2 hours and 15 minutes.
								For how many minutes did Juliene practice her dance routine on Monday?
							</label>

							<br />
							<button type="button" className="gray-button" onClick={() => text2Speech(5)}>Text to Speech</button>
							<button type="button" className="gray-button" onClick={() => translateText(5)}>Translate</button>
							<br /><br />

							<input className="larger-text" type="text" id="T5" name="answer5" size="5" /><br />
						</li>

						<br /><br />

						<li>
							<label id="question6">
								A number <i>x</i> is at most 17 less than 5 times the value of <i>y</i>.
								If the value of <i>y</i> is 3, what is the greatest possible value of <i>x</i>?
							</label>

							<br />
							<button type="button" className="gray-button" onClick={() => text2Speech(6)}>Text to Speech</button>
							<button type="button" className="gray-button" onClick={() => translateText(6)}>Translate</button>
							<br /><br />

							<input className="larger-text" type="text" id="T6" name="answer6" size="5" /><br />
						</li>

						<br /><br />

						<li>
							<label id="question7">
								The product of two positive integers is 462.
								If the first integer is 5 greater than twice the second integer,
								what is the smaller of the two integers?
							</label>

							<br />
							<button type="button" className="gray-button" onClick={() => text2Speech(7)}>Text to Speech</button>
							<button type="button" className="gray-button" onClick={() => translateText(7)}>Translate</button>
							<br /><br />

							<input className="larger-text" type="text" id="T7" name="answer5" size="5" /><br />
						</li>

						<br /><br />

						<li>
							<label id="question8">
								In a college archaeology class, 78 students are going to a dig site to find and study artifacts.
								The dig site has been divided into 24 sections, and each section will be studied by a group of either 2 or 4 students.
								How many of the sections will be studied by a group of 2 students?
							</label>

							<br />
							<button type="button" className="gray-button" onClick={() => text2Speech(8)}>Text to Speech</button>
							<button type="button" className="gray-button" onClick={() => translateText(8)}>Translate</button>
							<br /><br />

							<input className="larger-text" type="text" id="T8" name="answer6" size="5" /><br />
						</li>
					</ol>

				</div>
			</>
		);
	}
}
